/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  ShareAltOutlined,
} from '@ant-design/icons';
import { Button, Checkbox, Col, Form, Input, InputNumber, Modal, Row, Select, Table, Tag, Tooltip, } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import colorsDark from '../../assets/colors/dark';
import LazyloadingSelect from '../../components/LazyloadingSelect/LazyloadingSelect';
import * as SERVICE from '../../constants/service.types';
import { NAMESPACE, NOTIFIES, DECODED_ACCESS_TOKEN } from '../../constants/system.keys';
import * as ACTIONS from '../../redux/actions';
import { openMessage, socketEmitEvent } from '../../redux/actions';
import './index.scss';
import { getReportAccountApi } from '../../api/reportApi';
import storageService from '../../services/storage.service';

const { confirm } = Modal;
const { Search } = Input;

const OrganizationPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [cameras, setCameras] = useState({
    data: [],
    pagination: {
      size: 'small',
    },
    loading: false,
  });
  const [camerasByUser, setCamerasByUser] = useState({
    data: [],
    pagination: {
      size: 'small',
    },
    loading: false,
  });
  const [cameraGroups, setCameraGroups] = useState({
    data: [],
    pagination: {
      size: 'small',
    },
    loading: false,
  });
  const [stepAdd, setStepAdd] = useState(0);
  const [, forceUpdate] = useState();
  const {
    searchContacts,
    dataUser,
    isAuth,
    cameras: pageCamera,
    listDeviceByUser,
    userShareDevice,
    sharePermissionUsers,
    unShareUser,
    deleteSharePermissionGroup,
    namespace,
    groupMembers,
    sharePermissionGroup,
    accountByNamespace,
    userId,
    updateSharePermissionGroup,
    deviceGroup,
    listDeviceGroupByPage,
    userGroupsByDeviceGroups,
  } = useSelector((state) => state);
  const [isAddUserLoading, setIsAddUserLoading] = useState(false);
  const [timeRequest, setTimeRequest] = useState(new Date().getTime());
  const [userShares, setUserShares] = useState();
  const [userShareGroupDevice, setUserShareGroupDevices] = useState();
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [checkSelect, setCheckSelect] = useState(null);
  const [filterAccountId, setFilterAccountId] = useState(null);
  const [filterGroupId, setFilterGroupId] = useState(null);
  const [filterSerial, setFilterSerial] = useState(null);
  const [duration, setDuration] = useState(0);
  const [checkFilterShare, setCheckFilterSharel] = useState(null);
  const [checkUpdate, setCheckUpdate] = useState(null);
  const [checkEdit, setCheckEdit] = useState(null);
  const [checkCam, setCheckCam] = useState(false);
  const [searchContactData, setSearchContactData] = useState(searchContacts);
  const [checkAccountId, setCheckAccountId] = useState(null);
  const [checkGroupId, setCheckGroupId] = useState(false);
  const [checkSerial, setCheckSerial] = useState(false);
  const [keyTable, setKeyTable] = useState(Math.random());
  const [dataSearchCamera, setDataSearchCamera] = useState();
  const [dataSearchGroupCamera, setDataSearchGroupCamera] = useState();
  const [dataSelect, setDataSelect] = useState(0);
  const [dataGroupDefault, setDataGroupDefault] = useState();
  const [dataPermission, setDataPermission] = useState([]);
  const [dataPermissionSubmit, setDataPermissionSubmit] = useState([]);
  const [currentCameragroup, setCurrentCameraGroup] = useState({
    value: 0,
    label: t('All camera'),
  });
  const [step, setStep] = useState(0);
  const [dataSelectByUser, setDataSelectByUser] = useState();
  const [isAdmin, setIsAdmin] = useState(false);
  const [dataShareUserId, setDataShareUserId] = useState();
  const [timeRequestCameraGroup, setTimeRequestCameraGroup] = useState(
    new Date().getTime()
  );
  const [dataGroupIdSelect, setDataGroupIdSelect] = useState();
  const [accountResult, setAccountResult] = useState([]);
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  useEffect(() => {
    setAccountResult(accountByNamespace);
  }, [accountByNamespace]);

  useEffect(() => {
    forceUpdate({});
  }, []);

  const getUserShareData = useCallback(
    (serials) => {
      /**
       * @params serials @Array of serials
       */

      if (serials) {
        let dataBody = {
          serials: serials.join(';'),
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_USER_SHARE_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        setCheckCam(true);
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace]
  );

  const getListGroupAccountByDeviceGroup = useCallback(
    (groupIds) => {
      /**
       * @params serials @Array of serials
       */

      if (groupIds?.length > 0) {
        let dataBody = {
          deviceGroupId: groupIds[0],
          namespace,
          timeRequest: new Date().getTime(),
          page: 0,
          size: 100,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_GROUP_ACCOUNT_BY_DEVICE_GROUP_BY_PAGE,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        setCheckCam(true);
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace]
  );

  useEffect(() => {
    if (
      sharePermissionUsers &&
      sharePermissionUsers.requestId === timeRequest
    ) {
      setIsAddUserLoading(false);
      if (sharePermissionUsers.result === 1) {
        openMessage(NOTIFIES.SUCCESS, sharePermissionUsers.message);
        const serials = sharePermissionUsers?.data?.shares.map(
          (device) => device?.deviceSerial
        );
        const deviceGroupIdTemp = sharePermissionUsers?.data?.shares?.find(
          (device) => device?.deviceGroupId >= 0
        );
        form.resetFields();
        if (deviceGroupIdTemp) {
          getListGroupAccountByDeviceGroup([deviceGroupIdTemp?.deviceGroupId]);
        } else if (serials && userShares && userShares.serials) {
          getUserShareData([userShares.serials]);
        }
      } else {
        openMessage(NOTIFIES.WARNING, sharePermissionUsers.message);
      }
    }
  }, [form, getUserShareData, sharePermissionUsers]);

  useEffect(() => {
    if (
      sharePermissionGroup &&
      sharePermissionGroup.requestId === timeRequest
    ) {
      setIsAddUserLoading(false);
      if (sharePermissionGroup.result === 1) {
        openMessage(NOTIFIES.SUCCESS, sharePermissionGroup.message);
        let serials =
          (sharePermissionGroup.data &&
            sharePermissionGroup.data.shares &&
            sharePermissionGroup.data.shares[0] &&
            sharePermissionGroup.data.shares[0].deviceSerial) ||
          '';
        form.resetFields();
        if (serials && userShares && userShares.serials) {
          getUserShareData([userShares.serials]);
        }
      } else {
        openMessage(NOTIFIES.WARNING, sharePermissionGroup.message);
      }
    }
  }, [form, getUserShareData, sharePermissionGroup]);

  useEffect(() => {
    if (
      updateSharePermissionGroup &&
      updateSharePermissionGroup.requestId === timeRequest
    ) {
      setIsAddUserLoading(false);
      if (updateSharePermissionGroup.result === 1) {
        openMessage(NOTIFIES.SUCCESS, updateSharePermissionGroup.message);
        const serials =
          (updateSharePermissionGroup.data &&
            updateSharePermissionGroup.data.serials) ||
          '';
        const deviceGroupIdTemp =
          (updateSharePermissionGroup.data &&
            updateSharePermissionGroup.data.deviceGroupId) ||
          '';
        form.resetFields();
        if (deviceGroupIdTemp) {
          getListGroupAccountByDeviceGroup([deviceGroupIdTemp]);
        } else if (serials && userShares && userShares.serials) {
          getUserShareData([userShares.serials]);
        }
      } else {
        openMessage(NOTIFIES.WARNING, updateSharePermissionGroup.message);
      }
    }
  }, [form, getUserShareData, updateSharePermissionGroup]);

  useEffect(() => {
    if (unShareUser && unShareUser.requestId === timeRequest) {
      if (unShareUser.result === 1) {
        setIsDeleteLoading(null);
        openMessage(NOTIFIES.SUCCESS, unShareUser.message);
        const serials = (unShareUser.data && unShareUser.data.serials) || '';
        const deviceGroupIdTemp =
          (unShareUser.data && unShareUser.data.deviceGroupId) || '';
        form.resetFields();
        if (deviceGroupIdTemp) {
          getListGroupAccountByDeviceGroup([deviceGroupIdTemp]);
        } else if (serials && userShares && userShares.serials) {
          getUserShareData([userShares.serials]);
        }
      } else {
        openMessage(NOTIFIES.WARNING, unShareUser.message);
      }
    }
  }, [form, getUserShareData, unShareUser]);

  useEffect(() => {
    if (
      deleteSharePermissionGroup &&
      deleteSharePermissionGroup.requestId === timeRequest
    ) {
      if (deleteSharePermissionGroup.result === 1) {
        setIsDeleteLoading(null);
        openMessage(NOTIFIES.SUCCESS, deleteSharePermissionGroup.message);
        let serials =
          (deleteSharePermissionGroup.data &&
            deleteSharePermissionGroup.data.serials) ||
          '';
        form.resetFields();
        if (serials && userShares && userShares.serials) {
          getUserShareData([userShares.serials]);
        }
      } else {
        openMessage(NOTIFIES.WARNING, deleteSharePermissionGroup.message);
      }
    }
  }, [form, getUserShareData, deleteSharePermissionGroup]);

  useEffect(() => {
    setSearchContactData(searchContacts);
  }, [searchContacts]);

  useEffect(() => {
    if (userShareDevice) {
      setCheckUpdate(null);
      setCheckEdit(null);
      handleFiler();
    }
  }, [userShareDevice]);

  useEffect(() => {
    if (userGroupsByDeviceGroups?.deviceGroupId) {
      setCheckUpdate(null);
      setCheckEdit(null);
      handleFilerGroupDevice();
    }
  }, [userGroupsByDeviceGroups]);

  useEffect(() => {
    if (pageCamera && pageCamera.timeRequest === timeRequest) {
      setCameras((state) => ({
        ...state,
        loading: false,
        data: pageCamera.data,
        pagination: {
          ...state.pagination,
          total: pageCamera.totalSize,
        },
      }));
    }
  }, [pageCamera]);

  useEffect(() => {
    if (listDeviceByUser && listDeviceByUser.timeRequest === timeRequest) {
      setCamerasByUser((state) => ({
        ...state,
        loading: false,
        data: listDeviceByUser.devices,
        pagination: {
          ...state.pagination,
          total: listDeviceByUser.total,
        },
      }));
    }
  }, [listDeviceByUser]);

  useEffect(() => {
    if (isAuth === 1 && namespace && step === 2) {
      setCameraGroups((state) => ({ ...state, loading: true }));
      const dataTimeRequest = new Date().getTime();
      let data = {
        name: '',
        page: 0,
        size: 10,
        timeRequest: dataTimeRequest,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2,
        requestId: dataTimeRequest,
        body: JSON.stringify(data),
      };
      setTimeRequestCameraGroup(dataTimeRequest);
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace, timeRequest, step]);

  useEffect(() => {
    if (
      listDeviceGroupByPage &&
      listDeviceGroupByPage.timeRequest === timeRequestCameraGroup
    ) {
      setCameraGroups((state) => ({
        ...state,
        loading: false,
        data: listDeviceGroupByPage?.deviceGroups,
        pagination: {
          ...state.pagination,
          total: listDeviceGroupByPage?.total ?? 0,
        },
      }));
    }
  }, [listDeviceGroupByPage, timeRequestCameraGroup]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_GROUP_MEMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      setCameras((state) => ({ ...state, loading: true }));
      let data = {
        deviceType: 'camera',
        page: 0,
        size: 10,
        timeRequest,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    // get detail device group data
    if (deviceGroup?.requestId === timeRequest && deviceGroup?.deviceGroup) {
      const dataCameras = deviceGroup?.deviceGroup?.devices || [];
      setCameras((state) => ({
        ...state,
        loading: false,
        data: dataCameras,
        pagination: {
          ...state.pagination,
          current: 1,
          pageSize: dataCameras?.length ?? 0,
          total: dataCameras?.length ?? 0,
        },
      }));
      setDataGroupDefault(dataCameras);
    }
  }, [deviceGroup]);

  useEffect(() => {
    if (accountByNamespace && userId) {
      const isAdmin = accountByNamespace.some(
        (account) => account.accountId === userId && account.role === 'admin'
      );
      if (isAdmin) {
        setIsAdmin(true);
        return; // Dừng lại nếu tìm thấy isAdmin là true
      }
    }

    if (dataUser) {
      if (
        dataUser.role === 'admin' ||
        (dataUser.role === 'member' && dataUser.detailRole === 'operator')
      ) {
        setIsAdmin(true);
        return; // Dừng lại nếu tìm thấy isAdmin là true
      }
    }

    setIsAdmin(false); // Nếu không tìm thấy isAdmin là true, thì isAdmin sẽ là false
  }, [accountByNamespace, userId, dataUser]);

  const handleRemoveShareUser = useCallback(
    (groupId, accountId, serial, deviceGroupId) => {
      confirm({
        title:
          groupId === -1
            ? t('Are you sure to remove this member?')
            : t('Are you sure to remove this group member?'),
        icon: <ExclamationCircleOutlined />,

        onOk() {
          if (userShares?.serials || deviceGroupId) {
            if (userShares?.serials) {
              setIsDeleteLoading(userShares.serials);
            }
            let data = {
              serials: serial,
              groupId: groupId ?? -1,
              namespace,
              accountId: accountId ?? -1,
              deviceGroupId: deviceGroupId ?? -1,
            };
            console.log('data', data)
            const dataTimeRequest = new Date().getTime();
            setTimeRequest(dataTimeRequest);
            let dataObj = {
              appServiceType: SERVICE.UN_SHARE_PERMISSION_USER,
              requestId: dataTimeRequest,
              body: JSON.stringify(data),
            };
            setCheckSelect(null);
            setFilterAccountId(null);
            setFilterGroupId(null);
            setFilterSerial(null);
            setCheckFilterSharel(null);
            setDataPermissionSubmit([]);
            form.setFieldsValue({
              select: null,
              groupId: null,
              accountId: null,
            });
            return dispatch(socketEmitEvent(dataObj));
          }
        },
        onCancel() {},
      });
    },
    [dispatch, namespace, t, timeRequest, userShares]
  );

  const handleTableChange = useCallback(
    (pagination, _, sort) => {
      const { field, order } = sort;
      setCameras((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        loading: true,
      }));

      let data = {
        deviceType: 'camera',
        page: pagination.current - 1,
        size: pagination.pageSize,
        timeRequest,
        namespace,
        field,
        order,
      };
      if (dataSearchCamera) {
        data.name = dataSearchCamera;
      }
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, timeRequest, dataSearchCamera]
  );

  const handleTableChangeMember = useCallback(
    (pagination, _, sort) => {
      setCamerasByUser((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        loading: true,
      }));

      let data = {
        shareUserId: dataShareUserId,
        deviceType: 'camera',
        page: pagination.current - 1,
        size: pagination.pageSize,
        timeRequest,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_DEVICE_BY_USER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, timeRequest, dataShareUserId]
  );

  const handleTableChangeGroupDevice = useCallback(
    (pagination, _, sort) => {
      const dataTimeRequest = new Date().getTime();
      setCameraGroups((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        loading: true,
      }));

      let data = {
        name: '',
        page: pagination.current - 1,
        size: pagination.pageSize,
        timeRequest: dataTimeRequest,
        namespace,
      };
      if (dataSearchGroupCamera) {
        data.name = dataSearchGroupCamera;
      }
      let dataObj = {
        appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2,
        requestId: dataTimeRequest,
        body: JSON.stringify(data),
      };
      setTimeRequestCameraGroup(dataTimeRequest);
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, timeRequest, dataSearchGroupCamera]
  );

  const onShareUser = useCallback(
    (values) => {
      const { accountId, groupId, deviceGroupId } = values;
      confirm({
        title: deviceGroupId
          ? t('Are you sure to share those device groups?')
          : t('Are you sure to share those devices?'),
        icon: <ExclamationCircleOutlined />,
        onOk() {
          let dataBody = {
            serials: filterSerial ?? userShares?.serials ?? '',
            accountId: checkSelect !== '1' ? Number(accountId ?? -1) : -1,
            groupId: checkSelect === '1' ? Number(groupId ?? -1) : -1,
            deviceGroupId: Number(deviceGroupId ?? -1),
            namespace,
            permission: dataPermissionSubmit.join('_'),
            durationSecond: duration === 0 ? -1 : duration * 86400,
          };
          const dataTimeRequest = new Date().getTime();
          setTimeRequest(dataTimeRequest);
          let dataObj = {
            appServiceType: SERVICE.SHARE_PERMISSION_USER,
            requestId: dataTimeRequest,
            body: JSON.stringify(dataBody),
          };
          setCheckSelect(null);
          setFilterAccountId(null);
          setFilterGroupId(null);
          setFilterSerial(null);
          setCheckFilterSharel(null);
          setDataPermissionSubmit([]);
          form.setFieldsValue({
            select: null,
            groupId: null,
            accountId: null,
          });
          return dispatch(socketEmitEvent(dataObj));
        },
        onCancel() {},
      });
    },
    [
      checkSelect,
      dispatch,
      namespace,
      t,
      timeRequest,
      userShares,
      dataPermissionSubmit,
      duration,
    ]
  );

  const handleCancelShare = () => {
    setCheckUpdate(null);
    setCheckEdit(null);
    if (userShareGroupDevice?.deviceGroupId) {
      handleFilerGroupDevice();
    } else {
      handleFiler();
    }
  };

  const handleUpdateShare = (
    groupId,
    accountId,
    permission,
    serial,
    deviceGroupId
  ) => {
    const dataBody = {
      serials: serial,
      accountId: Number(accountId ?? -1),
      namespace,
      groupId: Number(groupId ?? -1),
      deviceGroupId: Number(deviceGroupId ?? -1),
      permission: permission,
    };
    const dataTimeRequest = new Date().getTime();
    setTimeRequest(dataTimeRequest);
    let dataObj = {
      appServiceType: SERVICE.UPDATE_SHARE_PERMISSION_USER,
      requestId: dataTimeRequest,
      body: JSON.stringify(dataBody),
    };

    return dispatch(socketEmitEvent(dataObj));
  };

  const handleFilerType = (type) => {
    if (userShareGroupDevice?.deviceGroupId) {
    } else {
      if (type === '1') {
        const data =
          (userShareDevice &&
            userShareDevice.users &&
            userShareDevice.users.length > 0 &&
            userShareDevice.users.filter((item) => item.groupId !== -1)) ||
          [];
        setUserShares({
          serials: userShareDevice.serials,
          users: [...data],
        });
      }
      if (type === '2') {
        const data =
          (userShareDevice &&
            userShareDevice.users &&
            userShareDevice.users.length > 0 &&
            userShareDevice.users.filter((item) => item.groupId === -1)) ||
          [];
        setUserShares({
          serials: userShareDevice.serials,
          users: [...data],
        });
      }
    }
  };

  const handleFilerGroup = (value) => {
    const data =
      (userShareDevice &&
        userShareDevice.users &&
        userShareDevice.users.length > 0 &&
        userShareDevice.users.filter(
          (item) => item.groupId === Number(value)
        )) ||
      [];
    const serials =
      (userShareDevice &&
        userShareDevice.serials &&
        userShareDevice.serials.split(';')) ||
      [];
    let count = 0;
    let dataSerial = '';
    serials &&
      serials.length > 0 &&
      serials.map((item) => {
        if (data.find((item1) => item === item1.serial)) {
          count += 1;
        } else {
          dataSerial = `${dataSerial}${item};`;
        }
      });
    if (count === serials.length) {
      setCheckFilterSharel(false);
    } else if (count > 0) {
      setCheckFilterSharel(true);
      setFilterSerial(dataSerial);
    } else {
      setCheckFilterSharel(true);
    }
    setUserShares({
      serials: userShareDevice.serials,
      users: [...data],
    });
  };

  const handleFilerGroupDeviceSelect = (value) => {
    const dataGroupsTemp =
      userShareGroupDevice?.groups?.filter(
        (item) => item.id === Number(value)
      ) || [];
    setCheckFilterSharel(true);
    setUserShareGroupDevices({
      ...userShareGroupDevice,
      groups: [...dataGroupsTemp],
    });
  };

  const handleFilerMember = (value) => {
    const data =
      (userShareDevice &&
        userShareDevice.users &&
        userShareDevice.users.length > 0 &&
        userShareDevice.users.filter(
          (item) =>
            item.accountId === Number(value) &&
            !(item.child && item.child.length > 0)
        )) ||
      [];
    const serials =
      (userShareDevice &&
        userShareDevice.serials &&
        userShareDevice.serials.split(';')) ||
      [];
    let count = 0;
    let dataSerial = '';
    serials &&
      serials.length > 0 &&
      serials.map((item) => {
        if (data.find((item1) => item === item1.serial)) {
          count += 1;
        } else {
          dataSerial = `${dataSerial}${item};`;
        }
      });
    if (count === serials.length) {
      setCheckFilterSharel(false);
    } else if (count > 0) {
      setCheckFilterSharel(true);
      setFilterSerial(dataSerial);
    } else {
      setCheckFilterSharel(true);
    }
    setUserShares({
      serials: userShareDevice.serials,
      users: [...data],
    });
  };

  const handleFiler = () => {
    if (checkSelect) {
      if (filterGroupId && !filterAccountId) {
        const data =
          (userShareDevice &&
            userShareDevice.users &&
            userShareDevice.users.length > 0 &&
            userShareDevice.users.filter(
              (item) => item.groupId === Number(filterGroupId)
            )) ||
          [];
        setUserShares({
          serials: userShareDevice.serials,
          users: [...data],
        });
      } else if (!filterGroupId && filterAccountId) {
        const data =
          (userShareDevice &&
            userShareDevice.users &&
            userShareDevice.users.length > 0 &&
            userShareDevice.users.filter(
              (item) =>
                item.accountId === Number(filterAccountId) &&
                !(item.child && item.child.length > 0)
            )) ||
          [];
        setUserShares({
          serials: userShareDevice.serials,
          users: [...data],
        });
      } else {
        if (checkSelect === '1') {
          const data =
            (userShareDevice &&
              userShareDevice.users &&
              userShareDevice.users.length > 0 &&
              userShareDevice.users.filter((item) => item.groupId !== -1)) ||
            [];
          setUserShares({
            serials: userShareDevice.serials,
            users: [...data],
          });
        }
        if (checkSelect === '2') {
          const data =
            (userShareDevice &&
              userShareDevice.users &&
              userShareDevice.users.length > 0 &&
              userShareDevice.users.filter((item) => item.groupId === -1)) ||
            [];
          setUserShares({
            serials: userShareDevice.serials,
            users: [...data],
          });
        }
      }
    } else {
      setUserShares({ ...userShareDevice });
    }
  };

  const handleFilerGroupDevice = () => {
    setUserShareGroupDevices({ ...userGroupsByDeviceGroups });
  };

  const handleSearchAccount = (value) => {
    if (value.target.value) {
      const data = accountByNamespace.filter((item) =>
        item.fullName.toLowerCase().includes(value.target.value.toLowerCase())
      );
      setAccountResult(data);
    }
  };

  const expandedRowRender = (data) => {
    const columns1 = [
      {
        title: t('Camera'),
        dataIndex: 'serial',
        key: 'serial-share-device',
        width: '23%',
        render: (cell) => {
          const data =
            cameras &&
            cameras.data &&
            cameras.data.length > 0 &&
            cameras.data.find((item) => item.serial === cell);
          return (data && data.name) || '';
        },
      },
      {
        title: t('Full name'),
        dataIndex: 'fullName',
        key: 'fullName-share-device',
        width: '10%',
      },
      {
        title: t('Phone'),
        dataIndex: 'phoneNumber',
        key: 'phoneNumber-share-device',
        width: '13%',
      },
      {
        title: t('Permission'),
        key: 'permission-share-device',
        dataIndex: 'permission',
        width: '32%',
        render: (cell, row, index) => {
          const dataArr = (cell && cell.split('_')) || [];
          let check1 = false;
          let check2 = false;
          let check3 = false;
          let check4 = false;
          let check5 = false;
          if (dataArr.find((item) => item === 'live')) {
            check1 = true;
          }
          if (dataArr.find((item) => item === 'playback')) {
            check2 = true;
          }
          if (dataArr.find((item) => item === 'download')) {
            check3 = true;
          }
          if (dataArr.find((item) => item === 'upload')) {
            check4 = true;
          }
          if (dataArr.find((item) => item === 'share')) {
            check5 = true;
          }
          const onChange = (e, key) => {
            if (key === 'live') {
              let data = { ...userShares };
              let data1 = [];
              if (!check1) {
                data1 = ['live'];
              }
              if (check2) {
                data1 = [...data1, 'playback'];
              }
              if (check3) {
                data1 = [...data1, 'download'];
              }
              if (check4) {
                data1 = [...data1, 'upload'];
              }
              if (check5) {
                data1 = [...data1, 'share'];
              }
              const data2 = data.users.map((item, index1) => {
                if (item.child) {
                  if (
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    let dataItem1 = [...item.child];
                    dataItem1[checkUpdate] = {
                      ...dataItem1[checkUpdate],
                      permission: data1.join('_'),
                    };
                    return {
                      ...item,
                      permission: data1.join('_'),
                      child: [...dataItem1],
                    };
                  } else {
                    return item;
                  }
                } else {
                  if (
                    item.accountId === checkAccountId &&
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    return { ...item, permission: data1.join('_') };
                  } else {
                    return item;
                  }
                }
              });
              setCheckUpdate(index);
              setUserShares({ ...data, users: [...data2] });
            } else if (key === 'playback') {
              let data = { ...userShares };
              let data1 = [];
              if (check1) {
                data1 = ['live'];
              }
              if (!check2) {
                data1 = [...data1, 'playback'];
              }
              if (check3) {
                data1 = [...data1, 'download'];
              }
              if (check4) {
                data1 = [...data1, 'upload'];
              }
              if (check5) {
                data1 = [...data1, 'share'];
              }
              const data2 = data.users.map((item, index1) => {
                if (item.child) {
                  if (
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    let dataItem1 = [...item.child];
                    dataItem1[checkUpdate] = {
                      ...dataItem1[checkUpdate],
                      permission: data1.join('_'),
                    };
                    return {
                      ...item,
                      permission: data1.join('_'),
                      child: [...dataItem1],
                    };
                  } else {
                    return item;
                  }
                } else {
                  if (
                    item.accountId === checkAccountId &&
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    return { ...item, permission: data1.join('_') };
                  } else {
                    return item;
                  }
                }
              });
              setCheckUpdate(index);
              setUserShares({ ...data, users: [...data2] });
            } else if (key === 'download') {
              let data = { ...userShares };
              let data1 = [];
              if (check1) {
                data1 = ['live'];
              }
              if (check2) {
                data1 = [...data1, 'playback'];
              }
              if (!check3) {
                data1 = [...data1, 'download'];
              }
              if (check4) {
                data1 = [...data1, 'upload'];
              }
              if (check5) {
                data1 = [...data1, 'share'];
              }
              const data2 = data.users.map((item, index1) => {
                if (item.child) {
                  if (
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    let dataItem1 = [...item.child];
                    dataItem1[checkUpdate] = {
                      ...dataItem1[checkUpdate],
                      permission: data1.join('_'),
                    };
                    return {
                      ...item,
                      permission: data1.join('_'),
                      child: [...dataItem1],
                    };
                  } else {
                    return item;
                  }
                } else {
                  if (
                    item.accountId === checkAccountId &&
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    return { ...item, permission: data1.join('_') };
                  } else {
                    return item;
                  }
                }
              });
              setCheckUpdate(index);
              setUserShares({ ...data, users: [...data2] });
            } else if (key === 'upload') {
              let data = { ...userShares };
              let data1 = [];
              if (check1) {
                data1 = ['live'];
              }
              if (check2) {
                data1 = [...data1, 'playback'];
              }
              if (check3) {
                data1 = [...data1, 'download'];
              }
              if (!check4) {
                data1 = [...data1, 'upload'];
              }
              if (check5) {
                data1 = [...data1, 'share'];
              }
              const data2 = data.users.map((item, index1) => {
                if (item.child) {
                  if (
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    let dataItem1 = [...item.child];
                    dataItem1[checkUpdate] = {
                      ...dataItem1[checkUpdate],
                      permission: data1.join('_'),
                    };
                    return {
                      ...item,
                      permission: data1.join('_'),
                      child: [...dataItem1],
                    };
                  } else {
                    return item;
                  }
                } else {
                  if (
                    item.accountId === checkAccountId &&
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    return { ...item, permission: data1.join('_') };
                  } else {
                    return item;
                  }
                }
              });
              setCheckUpdate(index);
              setUserShares({ ...data, users: [...data2] });
            } else if (key === 'share') {
              let data = { ...userShares };
              let data1 = [];
              if (check1) {
                data1 = ['live'];
              }
              if (check2) {
                data1 = [...data1, 'playback'];
              }
              if (check3) {
                data1 = [...data1, 'download'];
              }
              if (check4) {
                data1 = [...data1, 'upload'];
              }
              if (!check5) {
                data1 = [...data1, 'share'];
              }
              const data2 = data.users.map((item, index1) => {
                if (item.child) {
                  if (
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    let dataItem1 = [...item.child];
                    dataItem1[checkUpdate] = {
                      ...dataItem1[checkUpdate],
                      permission: data1.join('_'),
                    };
                    return {
                      ...item,
                      permission: data1.join('_'),
                      child: [...dataItem1],
                    };
                  } else {
                    return item;
                  }
                } else {
                  if (
                    item.accountId === checkAccountId &&
                    item.groupId === checkGroupId &&
                    item.serial === checkSerial
                  ) {
                    return { ...item, permission: data1.join('_') };
                  } else {
                    return item;
                  }
                }
              });
              setCheckUpdate(index);
              setUserShares({ ...data, users: [...data2] });
            }
          };
          return (
            <React.Fragment>
              <Checkbox
                disabled={
                  !(
                    checkEdit === index &&
                    checkAccountId === row.accountId &&
                    checkGroupId === row.groupId &&
                    checkSerial === row.serial &&
                    dataPermission?.find((item) => item === 'live')
                  )
                }
                onChange={(e) => onChange(e, 'live')}
                checked={check1}
              >
                {t('Live')}
              </Checkbox>
              <Checkbox
                disabled={
                  !(
                    checkEdit === index &&
                    checkAccountId === row.accountId &&
                    checkGroupId === row.groupId &&
                    checkSerial === row.serial &&
                    dataPermission?.find((item) => item === 'playback')
                  )
                }
                onChange={(e) => onChange(e, 'playback')}
                checked={check2}
              >
                {t('Playback')}
              </Checkbox>
              <Checkbox
                disabled={
                  !(
                    checkEdit === index &&
                    checkAccountId === row.accountId &&
                    checkGroupId === row.groupId &&
                    checkSerial === row.serial &&
                    dataPermission?.find((item) => item === 'download')
                  )
                }
                onChange={(e) => onChange(e, 'download')}
                checked={check3}
              >
                {t('Download')}
              </Checkbox>
              <Checkbox
                style={{ marginLeft: '0px' }}
                disabled={
                  !(
                    checkEdit === index &&
                    checkAccountId === row.accountId &&
                    checkGroupId === row.groupId &&
                    checkSerial === row.serial &&
                    dataPermission?.find((item) => item === 'upload')
                  )
                }
                onChange={(e) => onChange(e, 'upload')}
                checked={check4}
              >
                {t('Upload')}
              </Checkbox>
              <Checkbox
                style={{ marginLeft: '0px' }}
                disabled={
                  !(
                    checkEdit === index &&
                    checkAccountId === row.accountId &&
                    checkGroupId === row.groupId &&
                    checkSerial === row.serial &&
                    dataPermission?.find((item) => item === 'share')
                  )
                }
                onChange={(e) => onChange(e, 'share')}
                checked={check5}
              >
                {t('Share')}
              </Checkbox>
            </React.Fragment>
          );
        },
      },
      {
        title: t('Action'),
        key: 'action-share-device',
        width: '22%',
        render: (user, row, index) => {
          return (
            <div className="remove-users-button">
              {checkEdit === index &&
              checkAccountId === row.accountId &&
              checkGroupId === row.groupId &&
              checkSerial === row.serial ? (
                <>
                  <Button
                    loading={
                      isDeleteLoading === (userShares && userShares.serials)
                    }
                    style={{ marginRight: '10px' }}
                    size="small"
                    type="primary"
                    onClick={() =>
                      handleUpdateShare(
                        row.groupId,
                        row.accountId,
                        row.permission,
                        row.serial
                      )
                    }
                  >
                    {t('Update')}
                  </Button>
                  <Button
                    loading={
                      isDeleteLoading === (userShares && userShares.serials)
                    }
                    size="small"
                    onClick={() => handleCancelShare()}
                  >
                    {t('Cancel')}
                  </Button>
                </>
              ) : (
                <div className="manager-member-actions">
                  <div
                    className="edit-button"
                    onClick={() => {
                      setCheckEdit(index);
                      setCheckUpdate(index);
                      setCheckAccountId(row.accountId);
                      setCheckGroupId(row.groupId);
                      setCheckSerial(row.serial);
                      handleFiler();
                    }}
                  >
                    <EditOutlined /> {t('Edit')}
                  </div>
                </div>
              )}
            </div>
          );
        },
      },
    ];

    return (
      <Table
        scroll={{ y: '100%' }}
        columns={columns1}
        dataSource={data && data.child ? data.child : [data]}
        pagination={false}
      />
    );
  };

  const onChangeSelect = (option) => {
    setCurrentCameraGroup(option);
    setDataSelect(option.value);
    if (option.value === 0) {
      setCameras((state) => ({
        ...state,
        loading: false,
        data: pageCamera.data,
        pagination: {
          size: 'small',
          current: 1,
          total: pageCamera.totalSize,
        },
      }));
    } else {
      const dataTimeRequest = new Date().getTime();
      setTimeRequest(dataTimeRequest);
      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.GET_DEVICE_GROUP_BY_ID,
          requestId: dataTimeRequest,
          body: JSON.stringify({
            namespace,
            deviceGroupId: option?.id,
            timeRequest,
          }),
        })
      );
    }
    onResetUserShare();
    setKeyTable(Math.random());
  };

  const onResetUserShare = () => {
    setCheckCam(false);
    form.resetFields();
    setIsAddUserLoading(false);
    setStepAdd(0);
    setCheckSelect(null);
    setFilterAccountId(null);
    setFilterGroupId(null);
    setFilterSerial(null);
    setCheckFilterSharel(null);
    setUserShares(null);
    setUserShareGroupDevices(null);
    setDataPermissionSubmit([]);
    setDataSearchCamera(null);
    setDataSearchGroupCamera(null);
    setTimeRequestCameraGroup(new Date().getTime());
    setDataGroupIdSelect(dataGroupIdSelect);
    form.setFieldsValue({
      select: null,
    });
  };

  const removeAccents = (str) => {
    return str
      ? str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/đ/g, 'd')
          .replace(/Đ/g, 'D')
      : '';
  };

  const onSearchCamera = (name) => {
    setDataSearchCamera(name?.trim());
    if (dataSelect === 0) {
      setCameras((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: 1,
          pageSize: 10,
        },
        loading: true,
      }));
      let data = {
        deviceType: 'camera',
        page: 0,
        size: 10,
        timeRequest,
        namespace,
      };
      if (name?.trim()) {
        data.name = name?.trim();
      }
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    } else {
      if (name?.trim()) {
        const dataName = removeAccents(name?.trim()?.toLowerCase());
        const dataSearch =
          dataGroupDefault?.filter((item) =>
            removeAccents(item.name?.toLowerCase())?.includes(dataName)
          ) ?? [];
        setCameras((state) => ({
          ...state,
          loading: false,
          data: dataSearch,
          pagination: {
            ...state.pagination,
            current: 1,
            pageSize: dataSearch?.length ?? 0,
            total: dataSearch?.length ?? 0,
          },
        }));
      } else {
        setCameras((state) => ({
          ...state,
          loading: false,
          data: dataGroupDefault,
          pagination: {
            ...state.pagination,
            current: 1,
            pageSize: dataGroupDefault?.length ?? 0,
            total: dataGroupDefault?.length ?? 0,
          },
        }));
      }
    }
  };

  const onSearchGroupCamera = (name) => {
    setDataSearchGroupCamera(name?.trim());
    const dataTimeRequest = new Date().getTime();
    setCameraGroups((state) => ({
      ...state,
      pagination: {
        ...state.pagination,
        current: 1,
        pageSize: 10,
      },
      loading: true,
    }));
    let data = {
      name: '',
      page: 0,
      size: 10,
      timeRequest: dataTimeRequest,
      namespace,
    };
    if (name?.trim()) {
      data.name = name?.trim();
    }
    let dataObj = {
      appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2,
      requestId: dataTimeRequest,
      body: JSON.stringify(data),
    };
    setTimeRequestCameraGroup(dataTimeRequest);
    dispatch(socketEmitEvent(dataObj));
  };

  const handlePermissionCamera = (args) => {
    console.log('keys: ', args);
    let dataTemp = [];
    if (!args?.find((item) => !item?.permission?.includes('live'))) {
      dataTemp.push('live');
    }
    if (!args?.find((item) => !item?.permission?.includes('playback'))) {
      dataTemp.push('playback');
    }
    if (!args?.find((item) => !item?.permission?.includes('download'))) {
      dataTemp.push('download');
    }
    if (!args?.find((item) => !item?.permission?.includes('upload'))) {
      dataTemp.push('upload');
    }
    if (!args?.find((item) => !item?.permission?.includes('share'))) {
      dataTemp.push('share');
    }
    setDataPermission(dataTemp);
  };

  const handleListDeviceByUser = useCallback((value) => {
    if (value) {
      setCamerasByUser((state) => ({ ...state, loading: true }));
      let dataBody = {
        shareUserId: value,
        deviceType: 'camera',
        namespace,
        page: 0,
        size: 10,
        timeRequest,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_DEVICE_BY_USER,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      setDataShareUserId(value);
      onResetUserShare();
      return dispatch(socketEmitEvent(dataObj));
    }
  }, []);

  const onRemovePermission = useCallback(
    (camera) => {
      confirm({
        title: t('_REMOVE_PERMISSION', { name: camera?.name }),
        icon: <ExclamationCircleOutlined />,
        okText: t('Remove'),
        onOk() {
          let data = {
            serials: camera?.serial,
            groupId: -1,
            namespace,
            accountId: dataSelectByUser,
          };
          let dataObj = {
            appServiceType: SERVICE.UN_SHARE_PERMISSION_USER,
            requestId: timeRequest,
            body: JSON.stringify(data),
          };
          setCamerasByUser((state) => ({ ...state, loading: true }));
          setTimeout(() => {
            handleListDeviceByUser(dataSelectByUser);
          }, 300);
          return dispatch(socketEmitEvent(dataObj));
        },
        onCancel() {},
      });
    },
    [dispatch, t, namespace, dataSelectByUser]
  );

  const handleExportAccountReports = useCallback(async () => {
    try {
      setIsLoadingExport(true);
      const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
      const namespace = localStorage.getItem(NAMESPACE);
      const dataQuery = {
        namespace,
        customerNamespace: namespace,
        isDownload: 1,
      };
      const dataRes = await getReportAccountApi(
        token,
        { namespace },
        dataQuery
      );
      console.log('dataRes: ', dataRes);
      setTimeout(() => {
        if (dataRes?.data) {
          const buttonElement = document.createElement('a');
          buttonElement.href = `data:text/csv;charset=utf-8,${encodeURI(
            dataRes.data
          )}`;
          buttonElement.target = '_blank';
          buttonElement.download = `report-account.csv`;
          buttonElement.click();
        } else {
          ACTIONS.openMessage(NOTIFIES.WARNING, 'No data export');
        }
        setIsLoadingExport(false);
      }, 800);
    } catch (error) {
      setTimeout(() => {
        setIsLoadingExport(false);
        ACTIONS.openMessage(
          NOTIFIES.WARNING,
          error?.response?.data?.message ?? 'Internal server error'
        );
      }, 800);
    }
  }, []);

  return (
    <div className="organization-component">
      {isAdmin && (
        <div className="button-tab">
          <div className="button-tab-left">
            <Button
              type={step === 0 ? 'primary' : 'default'}
              style={{ marginLeft: 'auto', width: '96px' }}
              onClick={() => {
                setStep(0);
                onResetUserShare();
                setKeyTable(Math.random());
              }}
            >
              {t('Camera')}
            </Button>
              <Button
              type={step === 2 ? 'primary' : 'default'}
              style={{ marginLeft: '8px' }}
              onClick={() => {
                setStep(2);
                onResetUserShare();
                setKeyTable(Math.random());
              }}
            >
              {t('Group camera')}
            </Button>
            <Button
              type={step === 1 ? 'primary' : 'default'}
              style={{ marginLeft: '8px', width: '96px' }}
              onClick={() => {
                setStep(1);
                onResetUserShare();
                setKeyTable(Math.random());
              }}
            >
              {t('Member')}
            </Button>
          
          </div>
          <div>
            <Button
              type={'primary'}
              style={{ marginLeft: '8px' }}
              icon={<DownloadOutlined />}
              loading={isLoadingExport}
              onClick={handleExportAccountReports}
            >
              {t('Export')}
            </Button>
          </div>
        </div>
      )}
      {step === 0 && (
        <div
          className="organization-component-camera"
          style={{ gridTemplateColumns: '2fr 5fr' }}
        >
          <div className="select-share-camera">
            <div
              className="search-camera"
              style={{ marginBottom: '8px', display: 'flex' }}
            >
              <LazyloadingSelect
                size={10}
                value={currentCameragroup}
                onChange={onChangeSelect}
                serviceId={SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2}
                searchField="name"
                reduxVariableName="listDeviceGroupByPage"
                defaultOption={{ value: 0, label: t('All camera') }}
                convertOptionData={(listDeviceGroupByPage) =>
                  listDeviceGroupByPage.deviceGroups?.map((item) => ({
                    ...item,
                    value: item.id,
                    label: item.name,
                  }))
                }
                selectProps={{
                  style: { width: '100%' },
                }}
              />
            </div>
            <div
              className="search-camera"
              style={{ marginBottom: '8px', display: 'flex' }}
            >
              <Search
                placeholder={t('Search camera')}
                onSearch={onSearchCamera}
                allowClear
              />
            </div>
            <div className="select-section">
              <Table
                key={keyTable}
                size="middle"
                scroll={{ y: 'calc(100vh - 327px)' }}
                dataSource={
                  cameras &&
                  cameras.data &&
                  cameras &&
                  cameras.data.map((camera) => ({
                    ...camera,
                    key: camera.serial,
                  }))
                }
                pagination={cameras && cameras.pagination}
                loading={cameras && cameras.loading}
                onChange={handleTableChange}
                rowSelection={{
                  getCheckboxProps: (record) => ({
                    disabled: !record?.permission?.includes('share'),
                    key: record.serial,
                  }),
                  preserveSelectedRowKeys: true,
                  onChange: (keys, row) => {
                    if (keys.length > 0) {
                      handlePermissionCamera(row);
                      return getUserShareData(keys);
                    } else {
                      return onResetUserShare();
                    }
                  },
                }}
                columns={[
                  {
                    title: t('Name'),
                    dataIndex: 'name',
                    key: 'name_of_camera_',
                    render: (cell, row) => {
                      return (
                        <div>
                          <div>{cell}</div>
                          <div
                            style={{
                              fontSize: '12px',
                              color: colorsDark.$online,
                              textDecoration: 'underline',
                            }}
                          >
                            {row?.permission?.replaceAll('_', ', ')}
                          </div>
                        </div>
                      );
                    },
                  },

                  {
                    title: t('State'),
                    key: 'state_of_camera',
                    dataIndex: 'state',
                    width: '85px',
                    render: (value) =>
                      value === 0 ? (
                        <Tag color={colorsDark.$offline}>{'Offline'}</Tag>
                      ) : (
                        <Tag color={colorsDark.$online}>{'Online'}</Tag>
                      ),
                  },
                ]}
              />
            </div>
          </div>
          <div className="table-organization-component">
            <Table
              pagination={false}
              footer={() => (
                <div className="select-share-user">
                  <style>
                    {`.table-organization-component .ant-table-footer {
                margin-top: -10px;
              }`}
                  </style>
                  {stepAdd === 0 ? (
                    <div className="share-user-button">
                      <div className="btn">
                        <Button
                          type="primary"
                          disabled={
                            !checkCam
                          }
                          onClick={() => setStepAdd(1)}
                          icon={<ShareAltOutlined />}
                        >
                          {t('Share access permission')}
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <Form
                      form={form}
                      name="add-user-permission"
                      layout="inline"
                      onFinish={(values) => onShareUser(values)}
                      initialValues={{
                        select: checkSelect,
                        groupId: `${filterGroupId}`,
                        accountId: `${filterAccountId}`,
                      }}
                    >
                      <Row style={{ width: '100%' }}>
                        <Col span={6}>
                          <Form.Item
                            name="select"
                            rules={[
                              {
                                required: true,
                                message: t('Please enter type'),
                              },
                            ]}
                          >
                            <Select
                              style={{ marginRight: '0px' }}
                              placeholder={t('Select type')}
                              onChange={(value) => {
                                setFilterAccountId(null);
                                setFilterGroupId(null);
                                setFilterSerial(null);
                                setCheckFilterSharel(null);
                                setCheckSelect(value);
                                handleFilerType(value);
                                form.setFieldsValue({
                                  groupId: null,
                                  accountId: null,
                                });
                              }}
                            >
                              <Select.Option key={1}>
                                {t('Group members')}
                              </Select.Option>
                              <Select.Option key={2}>
                                {t('Member')}
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        {checkSelect ? (
                          <Col span={6}>
                            {checkSelect === '1' ? (
                              <Form.Item
                                name="groupId"
                                rules={[
                                  {
                                    required: true,
                                    message: t('Please enter group members'),
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  style={{ marginRight: '0px' }}
                                  placeholder={t('Select group members')}
                                  onChange={(value) => {
                                    setFilterGroupId(Number(value));
                                    setFilterAccountId(null);
                                    handleFilerGroup(value);
                                  }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) => {
                                    return (
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    );
                                  }}
                                >
                                  {groupMembers.map((d) => (
                                    <Select.Option key={d.id}>
                                      {d.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            ) : (
                              <Form.Item
                                name="accountId"
                                rules={[
                                  {
                                    required: true,
                                    message: t('Please enter members'),
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  placeholder={t('Select members')}
                                  optionFilterProp="children"
                                  filterOption={(input, option) => {
                                    const data =
                                      (option &&
                                        option.children &&
                                        option.children.props &&
                                        option.children.props.children &&
                                        option.children.props.children[0] &&
                                        option.children.props.children[0]
                                          .props &&
                                        option.children.props.children[0].props
                                          .children) ||
                                      '';
                                    return (
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    );
                                  }}
                                  onChange={(value) => {
                                    setFilterAccountId(Number(value));
                                    setFilterGroupId(null);
                                    handleFilerMember(value);
                                  }}
                                >
                                  {accountByNamespace.map((d) => (
                                    <Select.Option key={d.accountId}>
                                      {/* <Row gutter={8}>
                                  <Col span={8}>{d.phonenumber}</Col>
                                  <Col span={10}><div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{d.fullName}</div></Col>
                                  <Col span={6}>
                                    <Tag color={memberRoleColors(d.role)}>
                                      {d.role && d.role.toUpperCase()}
                                    </Tag>
                                  </Col>
                                </Row> */}
                                      {d.fullName
                                        ? `${d.phonenumber} (${d.fullName})`
                                        : d.phonenumber}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            )}
                          </Col>
                        ) : (
                          <Col span={12}></Col>
                        )}
                        {checkSelect && (
                          <Col span={6}>
                            <Select
                              mode="multiple"
                              style={{ paddingRight: '16px', width: '100%' }}
                              placeholder={t('Select permission')}
                              onChange={(value) => {
                                setDataPermissionSubmit(value ?? []);
                              }}
                            >
                              {dataPermission.map((item) => (
                                <Select.Option
                                  key={item}
                                  style={{ textTransform: 'capitalize' }}
                                >
                                  {t(item[0].toUpperCase() + item.substring(1))}
                                </Select.Option>
                              ))}
                            </Select>
                          </Col>
                        )}
                        {checkSelect && (
                          <Col span={6}>
                            <InputNumber
                              style={{ width: '100%' }}
                              min={0}
                              placeholder="Please enter day"
                              value={duration}
                              formatter={(value) => `${value || ''} Day`}
                              parser={
                                (value) =>
                                  value
                                    .replace(/Da|D|Dy|a|ay|y|Day/g, '')
                                    .trim()
                                // Xử lý khi bấm backspace
                              }
                              onChange={(value) => {
                                setDuration(value);
                              }}
                            />
                          </Col>
                        )}
                      </Row>
                      <Row style={{ width: '100%', marginTop: '16px' }}>
                        <Col span={24}>
                          <div
                            className="button-side"
                            style={{ justifyContent: 'flex-end' }}
                          >
                            <Form.Item shouldUpdate={true}>
                              {() => (
                                <Button
                                  icon={<ShareAltOutlined />}
                                  htmlType="submit"
                                  type="primary"
                                  className="btn-add-share-person"
                                  loading={isAddUserLoading}
                                  disabled={
                                    !checkCam ||
                                    !checkFilterShare ||
                                    !userShares ||
                                    !userShares.serials ||
                                    !dataPermissionSubmit?.length ||
                                    duration === null ||
                                    form
                                      .getFieldsError()
                                      .filter(({ errors }) => errors.length)
                                      .length
                                  }
                                >
                                  {t('Share')}
                                </Button>
                              )}
                            </Form.Item>
                            <Form.Item>
                              <Button
                                onClick={() => {
                                  form.resetFields();
                                  setIsAddUserLoading(false);
                                  setStepAdd(0);
                                  setCheckSelect(null);
                                  setFilterAccountId(null);
                                  setFilterGroupId(null);
                                  setFilterSerial(null);
                                  setCheckFilterSharel(null);
                                  setUserShares({ ...userShareDevice });
                                  setDataPermissionSubmit([]);
                                  form.setFieldsValue({
                                    select: null,
                                  });
                                }}
                              >
                                {t('Cancel')}
                              </Button>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </div>
              )}
              columns={[
                {
                  title: t('Name'),
                  dataIndex: 'fullName',
                  key: 'fullName-share-device',
                  render: (cell, row) => {
                    return row.groupId === -1 ? cell : row.groupName;
                  },
                },
                {
                  title: t('Camera'),
                  dataIndex: 'serial',
                  key: 'serial-share-device',
                  render: (cell) => {
                    const data =
                      cameras &&
                      cameras.data &&
                      cameras.data.length > 0 &&
                      cameras.data.find((item) => item.serial === cell);
                    return (data && data.name) || '';
                  },
                },
                {
                  title: t('Type'),
                  key: 'type-share-device',
                  dataIndex: 'groupId',
                  render: (value) =>
                    value === -1 ? (
                      <Tag color={colorsDark.$offline}>{t('Member')}</Tag>
                    ) : (
                      <Tag color={colorsDark.$online}>{t('Group Member')}</Tag>
                    ),
                },
                {
                  title: t('Action'),
                  key: 'action-share-device',
                  width: '25%',
                  render: (user, row, index) => {
                    return (
                      <div className="remove-users-button">
                        <div className="manager-member-actions">
                          <div
                            className="edit-button"
                            onClick={() =>
                              handleRemoveShareUser(
                                row.groupId,
                                row.accountId,
                                row.serial
                              )
                            }
                          >
                            <DeleteOutlined /> {t('Remove')}
                          </div>
                        </div>
                      </div>
                    );
                  },
                },
              ]}
              dataSource={
                checkCam &&
                userShares &&
                userShares.users &&
                userShares.users.length > 0 &&
                userShares.users.map((user, index) => ({
                  ...user,
                  key: index,
                }))
              }
              scroll={{ y: '70vh' }}
              expandable={{ expandedRowRender }}
            />
          </div>
        </div>
      )}
      {step === 1 && (
        <div
          className="organization-component-camera tab-member"
          style={{ gridTemplateColumns: '2fr 5fr' }}
        >
          <div className="select-share-camera">
            <div
              className="search-camera"
              style={{ marginBottom: '8px', display: 'flex' }}
            >
              <Input placeholder="Search user" onChange={handleSearchAccount} />
            </div>
            <div className="select-section">
              <Table
                key={keyTable}
                size="middle"
                scroll={{ y: 'calc(100vh - 286px)' }}
                dataSource={accountResult?.map((account) => ({
                  ...account,
                  key: account.accountId,
                }))}
                rowSelection={{
                  type: 'radio',
                  selectedRowKeys,
                  getCheckboxProps: (record) => {
                    return {
                      key: record.accountId,
                    };
                  },
                  preserveSelectedRowKeys: true,
                  onChange: (keys, row) => {
                    setSelectedRowKeys(keys);
                    handleListDeviceByUser(keys[0]);
                  },
                }}
                columns={[
                  {
                    title: t('FullName'),
                    dataIndex: 'fullName',
                    key: 'fullName',
                    render: (cell, row) => {
                      return <div>{cell ? cell : '_'}</div>;
                    },
                  },
                  {
                    title: t('Phone Number'),
                    key: 'phonenumber',
                    dataIndex: 'phonenumber',
                    width: '120px',
                    render: (value) => value,
                  },
                ]}
              />
            </div>
          </div>
          <div className="table-organization-component">
            <Table
              key={keyTable}
              size="middle"
              scroll={{ y: 'calc(100vh - 286px)' }}
              dataSource={camerasByUser?.data?.map((camera) => ({
                ...camera,
                key: camera.serial,
              }))}
              pagination={camerasByUser?.pagination}
              loading={camerasByUser?.loading}
              onChange={handleTableChangeMember}
              columns={[
                {
                  title: t('Name'),
                  dataIndex: 'name',
                  key: 'name_of_camera_',
                  render: (cell, row) => {
                    return (
                      <div>
                        <div>{cell}</div>
                        <div
                          style={{
                            fontSize: '12px',
                            color: colorsDark.$online,
                            textDecoration: 'underline',
                          }}
                        >
                          {row?.permission?.replaceAll('_', ', ')}
                        </div>
                      </div>
                    );
                  },
                },
                {
                  title: t('State'),
                  key: 'state_of_camera',
                  dataIndex: 'state',
                  width: '85px',
                  render: (value) =>
                    value === 0 ? (
                      <Tag color={colorsDark.$offline}>{'Offline'}</Tag>
                    ) : (
                      <Tag color={colorsDark.$online}>{'Online'}</Tag>
                    ),
                },
                {
                  title: t('Action'),
                  key: 'actions ',
                  width: '60px',
                  align: 'center',
                  render: (record) => (
                    <Tooltip title={t('Remove permission')}>
                      <span
                        className="edit-button"
                        onClick={() => onRemovePermission(record)}
                        style={{ cursor: 'pointer' }}
                      >
                        <DeleteOutlined />
                      </span>
                    </Tooltip>
                  ),
                },
              ]}
            />
          </div>
        </div>
      )}
      {step === 2 && (
        <div
          className="organization-component-camera"
          style={{ gridTemplateColumns: '2fr 5fr' }}
        >
          <div className="select-share-camera">
            <div
              className="search-camera"
              style={{ marginBottom: '8px', display: 'flex' }}
            >
              <Search
                placeholder={t('Search group camera')}
                onSearch={onSearchGroupCamera}
                allowClear
              />
            </div>
            <div className="select-section">
              <Table
                key={keyTable}
                size="middle"
                scroll={{ y: 'calc(100vh - 327px)' }}
                dataSource={cameraGroups?.data?.map((cameraGroup) => ({
                  ...cameraGroup,
                  key: cameraGroup.id,
                }))}
                pagination={cameraGroups?.pagination}
                loading={cameraGroups?.loading}
                onChange={handleTableChangeGroupDevice}
                rowSelection={{
                  type: 'radio',
                  getCheckboxProps: (record) => ({
                    key: record.id,
                  }),
                  preserveSelectedRowKeys: true,
                  onChange: (keys, row) => {
                    if (keys.length > 0) {
                      handlePermissionCamera(row);
                      setDataGroupIdSelect(keys[0]);
                      return getListGroupAccountByDeviceGroup(keys);
                    } else {
                      setDataGroupIdSelect(null);
                      return onResetUserShare();
                    }
                  },
                }}
                columns={[
                  {
                    title: t('Name'),
                    dataIndex: 'name',
                    key: 'name_of_camera_',
                    render: (cell, row) => {
                      return (
                        <div>
                          <div>{cell}</div>
                          <div
                            style={{
                              fontSize: '12px',
                              color: colorsDark.$online,
                              textDecoration: 'underline',
                            }}
                          >
                            {row?.permission?.replaceAll('_', ', ')}
                          </div>
                        </div>
                      );
                    },
                  },

                  {
                    title: t('State'),
                    key: 'state_of_camera',
                    dataIndex: 'state',
                    width: '85px',
                    render: (value) =>
                      value === 0 ? (
                        <Tag color={colorsDark.$offline}>{'Offline'}</Tag>
                      ) : (
                        <Tag color={colorsDark.$online}>{'Online'}</Tag>
                      ),
                  },
                ]}
              />
            </div>
          </div>
          <div className="table-organization-component">
            <Table
              pagination={false}
              footer={() => (
                <div className="select-share-user">
                  <style>
                    {`.table-organization-component .ant-table-footer {
                margin-top: -10px;
              }`}
                  </style>
                  {stepAdd === 0 ? (
                    <div className="share-user-button">
                      <div className="btn">
                        <Button
                          type="primary"
                          disabled={
                            !checkCam
                          }
                          onClick={() => setStepAdd(1)}
                          icon={<ShareAltOutlined />}
                        >
                          {t('Share access permission')}
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <Form
                      form={form}
                      name="add-user-permission"
                      layout="inline"
                      onFinish={(values) =>
                        onShareUser({
                          ...values,
                          deviceGroupId: dataGroupIdSelect,
                        })
                      }
                      initialValues={{
                        select: checkSelect,
                        groupId: `${filterGroupId}`,
                        accountId: `${filterAccountId}`,
                      }}
                    >
                      <Row style={{ width: '100%' }}>
                        <Col span={6}>
                          <Form.Item
                            name="select"
                            rules={[
                              {
                                required: true,
                                message: t('Please enter type'),
                              },
                            ]}
                          >
                            <Select
                              style={{ marginRight: '0px' }}
                              placeholder={t('Select type')}
                              onChange={(value) => {
                                setFilterAccountId(null);
                                setFilterGroupId(null);
                                setFilterSerial(null);
                                setCheckFilterSharel(null);
                                setCheckSelect(value);
                                handleFilerType(value);
                                form.setFieldsValue({
                                  groupId: null,
                                  accountId: null,
                                });
                              }}
                            >
                              <Select.Option key={1}>
                                {t('Group members')}
                              </Select.Option>
                              <Select.Option key={2}>
                                {t('Member')}
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        {checkSelect ? (
                          <Col span={6}>
                            {checkSelect === '1' ? (
                              <Form.Item
                                name="groupId"
                                rules={[
                                  {
                                    required: true,
                                    message: t('Please enter group members'),
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  style={{ marginRight: '0px' }}
                                  placeholder={t('Select group members')}
                                  onChange={(value) => {
                                    setFilterGroupId(Number(value));
                                    setFilterAccountId(null);
                                    handleFilerGroupDeviceSelect(value);
                                  }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) => {
                                    return (
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    );
                                  }}
                                >
                                  {groupMembers.map((d) => (
                                    <Select.Option key={d.id}>
                                      {d.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            ) : (
                              <Form.Item
                                name="accountId"
                                rules={[
                                  {
                                    required: true,
                                    message: t('Please enter members'),
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  placeholder={t('Select members')}
                                  optionFilterProp="children"
                                  filterOption={(input, option) => {
                                    const data =
                                      (option &&
                                        option.children &&
                                        option.children.props &&
                                        option.children.props.children &&
                                        option.children.props.children[0] &&
                                        option.children.props.children[0]
                                          .props &&
                                        option.children.props.children[0].props
                                          .children) ||
                                      '';
                                    return (
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    );
                                  }}
                                  onChange={(value) => {
                                    setFilterAccountId(Number(value));
                                    setFilterGroupId(null);
                                    handleFilerMember(value);
                                  }}
                                >
                                  {accountByNamespace.map((d) => (
                                    <Select.Option key={d.accountId}>
                                      {d.fullName
                                        ? `${d.phonenumber} (${d.fullName})`
                                        : d.phonenumber}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            )}
                          </Col>
                        ) : (
                          <Col span={12}></Col>
                        )}
                        {checkSelect && (
                          <Col span={6}>
                            <Select
                              mode="multiple"
                              style={{ paddingRight: '16px', width: '100%' }}
                              placeholder={t('Select permission')}
                              onChange={(value) => {
                                setDataPermissionSubmit(value ?? []);
                              }}
                            >
                              {[
                                'live',
                                'playback',
                                'download',
                                'upload',
                                'share',
                              ].map((item) => (
                                <Select.Option
                                  key={item}
                                  style={{ textTransform: 'capitalize' }}
                                >
                                  {t(item[0].toUpperCase() + item.substring(1))}
                                </Select.Option>
                              ))}
                            </Select>
                          </Col>
                        )}
                        {checkSelect && (
                          <Col span={6}>
                            <InputNumber
                              style={{ width: '100%' }}
                              min={0}
                              placeholder="Please enter day"
                              value={duration}
                              formatter={(value) => `${value || ''} Day`}
                              parser={
                                (value) =>
                                  value
                                    .replace(/Da|D|Dy|a|ay|y|Day/g, '')
                                    .trim()
                                // Xử lý khi bấm backspace
                              }
                              onChange={(value) => {
                                setDuration(value);
                              }}
                            />
                          </Col>
                        )}
                        <Col span={24}>
                          <div
                            className="button-side"
                            style={{
                              justifyContent: 'flex-end',
                              marginTop: 16,
                            }}
                          >
                            <Form.Item shouldUpdate={true}>
                              {() => (
                                <Button
                                  icon={<ShareAltOutlined />}
                                  htmlType="submit"
                                  type="primary"
                                  className="btn-add-share-person"
                                  loading={isAddUserLoading}
                                  disabled={
                                    !checkCam ||
                                    !userShareGroupDevice.deviceGroupId ||
                                    !dataPermissionSubmit?.length ||
                                    duration === null ||
                                    form
                                      .getFieldsError()
                                      .filter(({ errors }) => errors.length)
                                      .length
                                  }
                                >
                                  {t('Share')}
                                </Button>
                              )}
                            </Form.Item>
                            <Form.Item>
                              <Button
                                onClick={() => {
                                  form.resetFields();
                                  setIsAddUserLoading(false);
                                  setStepAdd(0);
                                  setCheckSelect(null);
                                  setFilterAccountId(null);
                                  setFilterGroupId(null);
                                  setFilterSerial(null);
                                  setCheckFilterSharel(null);
                                  setUserShares({ ...userShareDevice });
                                  setDataPermissionSubmit([]);
                                  form.setFieldsValue({
                                    select: null,
                                  });
                                }}
                              >
                                {t('Cancel')}
                              </Button>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </div>
              )}
              columns={[
                {
                  title: t('Name'),
                  dataIndex: 'fullName',
                  key: 'fullName-share-device-group',
                  render: (cell, row) => {
                    return row.groupId ? row.groupName : cell;
                  },
                },
                {
                  title: t('Type'),
                  key: 'type-share-device',
                  dataIndex: 'groupId',
                  render: (value) =>
                    !!value && value !== -1 ? (
                       <Tag color={colorsDark.$online}>{t('Group Member')}</Tag>
                    ) : (
                      <Tag color={colorsDark.$offline}>{t('Member')}</Tag>
                    ),
                },
                {
                  title: t('Permission'),
                  key: 'permission-share-device',
                  dataIndex: 'permission',
                  width: '32%',
                  render: (cell, row, index) => {
                    const dataArr = (cell && cell.split('_')) || [];
                    let check1 = false;
                    let check2 = false;
                    let check3 = false;
                    let check4 = false;
                    let check5 = false;
                    if (dataArr.find((item) => item === 'live')) {
                      check1 = true;
                    }
                    if (dataArr.find((item) => item === 'playback')) {
                      check2 = true;
                    }
                    if (dataArr.find((item) => item === 'download')) {
                      check3 = true;
                    }
                    if (dataArr.find((item) => item === 'upload')) {
                      check4 = true;
                    }
                    if (dataArr.find((item) => item === 'share')) {
                      check5 = true;
                    }
                    const onChange = (e, key) => {
                      if (key === 'live') {
                        let data = { ...userShareGroupDevice };
                        let data1 = [];
                        if (!check1) {
                          data1 = ['live'];
                        }
                        if (check2) {
                          data1 = [...data1, 'playback'];
                        }
                        if (check3) {
                          data1 = [...data1, 'download'];
                        }
                        if (check4) {
                          data1 = [...data1, 'upload'];
                        }
                        if (check5) {
                          data1 = [...data1, 'share'];
                        }
                        const data2 = data.groups.map((item, index1) => {
                          if (item.id === checkGroupId) {
                            return { ...item, permission: data1.join('_') };
                          } else {
                            return item;
                          }
                        });
                        setCheckUpdate(index);
                        setUserShareGroupDevices({
                          ...data,
                          groups: [...data2],
                        });
                      } else if (key === 'playback') {
                        let data = { ...userShareGroupDevice };
                        let data1 = [];
                        if (check1) {
                          data1 = ['live'];
                        }
                        if (!check2) {
                          data1 = [...data1, 'playback'];
                        }
                        if (check3) {
                          data1 = [...data1, 'download'];
                        }
                        if (check4) {
                          data1 = [...data1, 'upload'];
                        }
                        if (check5) {
                          data1 = [...data1, 'share'];
                        }
                        const data2 = data.groups.map((item, index1) => {
                          if (item.id === checkGroupId) {
                            return { ...item, permission: data1.join('_') };
                          } else {
                            return item;
                          }
                        });
                        setCheckUpdate(index);
                        setUserShareGroupDevices({
                          ...data,
                          groups: [...data2],
                        });
                      } else if (key === 'download') {
                        let data = { ...userShareGroupDevice };
                        let data1 = [];
                        if (check1) {
                          data1 = ['live'];
                        }
                        if (check2) {
                          data1 = [...data1, 'playback'];
                        }
                        if (!check3) {
                          data1 = [...data1, 'download'];
                        }
                        if (check4) {
                          data1 = [...data1, 'upload'];
                        }
                        if (check5) {
                          data1 = [...data1, 'share'];
                        }
                        const data2 = data.groups.map((item, index1) => {
                          if (item.id === checkGroupId) {
                            return { ...item, permission: data1.join('_') };
                          } else {
                            return item;
                          }
                        });
                        setCheckUpdate(index);
                        setUserShareGroupDevices({
                          ...data,
                          groups: [...data2],
                        });
                      } else if (key === 'upload') {
                        let data = { ...userShareGroupDevice };
                        let data1 = [];
                        if (check1) {
                          data1 = ['live'];
                        }
                        if (check2) {
                          data1 = [...data1, 'playback'];
                        }
                        if (check3) {
                          data1 = [...data1, 'download'];
                        }
                        if (!check4) {
                          data1 = [...data1, 'upload'];
                        }
                        if (check5) {
                          data1 = [...data1, 'share'];
                        }
                        const data2 = data.groups.map((item, index1) => {
                          if (item.id === checkGroupId) {
                            return { ...item, permission: data1.join('_') };
                          } else {
                            return item;
                          }
                        });
                        setCheckUpdate(index);
                        setUserShareGroupDevices({
                          ...data,
                          groups: [...data2],
                        });
                      } else if (key === 'share') {
                        let data = { ...userShareGroupDevice };
                        let data1 = [];
                        if (check1) {
                          data1 = ['live'];
                        }
                        if (check2) {
                          data1 = [...data1, 'playback'];
                        }
                        if (check3) {
                          data1 = [...data1, 'download'];
                        }
                        if (check4) {
                          data1 = [...data1, 'upload'];
                        }
                        if (!check5) {
                          data1 = [...data1, 'share'];
                        }
                        const data2 = data.groups.map((item, index1) => {
                          if (item.id === checkGroupId) {
                            return { ...item, permission: data1.join('_') };
                          } else {
                            return item;
                          }
                        });
                        setCheckUpdate(index);
                        setUserShareGroupDevices({
                          ...data,
                          groups: [...data2],
                        });
                      }
                    };
                    return (
                      <React.Fragment>
                        <Checkbox
                          disabled={
                            !(checkEdit === index && checkGroupId === row.id)
                          }
                          onChange={(e) => onChange(e, 'live')}
                          checked={check1}
                        >
                          {t('Live')}
                        </Checkbox>
                        <Checkbox
                          disabled={
                            !(checkEdit === index && checkGroupId === row.id)
                          }
                          onChange={(e) => onChange(e, 'playback')}
                          checked={check2}
                        >
                          {t('Playback')}
                        </Checkbox>
                        <Checkbox
                          disabled={
                            !(checkEdit === index && checkGroupId === row.id)
                          }
                          onChange={(e) => onChange(e, 'download')}
                          checked={check3}
                        >
                          {t('Download')}
                        </Checkbox>
                        <Checkbox
                          style={{ marginLeft: '0px' }}
                          disabled={
                            !(checkEdit === index && checkGroupId === row.id)
                          }
                          onChange={(e) => onChange(e, 'upload')}
                          checked={check4}
                        >
                          {t('Upload')}
                        </Checkbox>
                        <Checkbox
                          style={{ marginLeft: '0px' }}
                          disabled={
                            !(checkEdit === index && checkGroupId === row.id)
                          }
                          onChange={(e) => onChange(e, 'share')}
                          checked={check5}
                        >
                          {t('Share')}
                        </Checkbox>
                        {/* </Radio.Group> */}
                      </React.Fragment>
                    );
                  },
                },
                {
                  title: t('Action'),
                  key: 'action-share-device',
                  width: '25%',
                  render: (user, row, index) => {
                    return (
                      <div className="remove-users-button">
                        <div>
                          {checkEdit === index && checkGroupId === row.id ? (
                            <>
                              <Button
                                loading={
                                  isDeleteLoading ===
                                  userShareGroupDevice?.deviceGroupId
                                }
                                style={{ marginRight: '10px' }}
                                size="small"
                                type="primary"
                                onClick={() =>
                                  handleUpdateShare(
                                    row.id,
                                    -1,
                                    row.permission,
                                    '',
                                    userShareGroupDevice?.deviceGroupId
                                  )
                                }
                              >
                                {t('Update')}
                              </Button>
                              <Button
                                loading={
                                  isDeleteLoading ===
                                  userShareGroupDevice?.deviceGroupId
                                }
                                size="small"
                                onClick={() => handleCancelShare()}
                              >
                                {t('Cancel')}
                              </Button>
                            </>
                          ) : (
                            <div className="manager-member-actions">
                              <div
                                className="edit-button"
                                onClick={() => {
                                  setCheckEdit(index);
                                  setCheckUpdate(index);
                                  setCheckGroupId(row.id);
                                  handleFilerGroupDevice();
                                }}
                              >
                                <EditOutlined /> {t('Edit')}
                              </div>
                              <div
                                className="edit-button"
                                  onClick={() => {
                                    console.log('row', row)
                                    handleRemoveShareUser(
                                      row?.groupId,
                                      row?.accountId,
                                      row?.serials,
                                      userShareGroupDevice?.deviceGroupId
                                    )
                                  }
                                
                                }
                              >
                                <DeleteOutlined /> {t('Remove')}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  },
                },
              ]}
              dataSource={
                checkCam &&
                userShareGroupDevice?.groups.map((groupItem, index) => ({
                  ...groupItem,
                  key: index,
                }))
              }
              scroll={{ y: '70vh' }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default OrganizationPage;
